var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Write"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.14286 19.8571H5.66075L16.8214 8.69654L15.3035 7.17865L4.14286 18.3392V19.8571ZM3.07671 22C2.77555 22 2.52085 21.8978 2.31263 21.6934C2.10421 21.4892 2 21.2361 2 20.9342V18.3489C2 18.0646 2.04959 17.7936 2.14877 17.5356C2.24795 17.2777 2.40668 17.0396 2.62496 16.8214L16.8214 2.62496C17.0396 2.40668 17.2761 2.24795 17.5308 2.14877C17.7855 2.04959 18.0534 2 18.3344 2C18.6155 2 18.8849 2.04959 19.1429 2.14877C19.4008 2.24795 19.6389 2.40668 19.8571 2.62496L21.375 4.14286C21.5933 4.36114 21.7521 4.59923 21.8512 4.85714C21.9504 5.11505 22 5.3784 22 5.64717C22 5.93365 21.9502 6.20675 21.8506 6.46647C21.751 6.72619 21.5925 6.96359 21.375 7.17865L7.17865 21.375C6.96037 21.5933 6.72278 21.752 6.46587 21.8512C6.20896 21.9504 5.93868 22 5.65502 22H3.07671ZM16.0491 7.95087L15.3035 7.17865L16.8214 8.69654L16.0491 7.95087Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.e00249cc2d53adcf4a158a326c3dd8ab.svg";
export { ForwardRef as ReactComponent };